import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FilterPipe } from '../../pipe/filter.pipe';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
const WAITTIME = 500;
//
@Component({
 selector: 'vcp-search-filter',
 templateUrl: './search-filter.component.html',
 styleUrls: ['./search-filter.component.scss'],
 providers: [FilterPipe]
})
export class SearchFilterComponent implements OnInit {
  @ViewChild('value', {read: ElementRef}) searchBox: ElementRef;
  @Output() action = new EventEmitter();
  @Input() list;
  @Input() from;

  constructor(private filterPipe: FilterPipe) {
  }

  ngOnInit(): void {
    // empty method
  }
  applyFilter(event) {
    if(this.from === 'deploymentList') return;
    let filterList;
    const value = (event.target as HTMLInputElement).value;
    if (value) {
      filterList = this.filterPipe.transform(this.list, value.trim(),'applicationDashboard');
    }
    this.action.emit({ filterList, value });
  }


  ngAfterViewInit(): void {
    fromEvent(this.searchBox.nativeElement, 'input')
    .pipe(
      map((event: Event) => (event.target as HTMLInputElement).value.trim()),
      debounceTime(WAITTIME),
      distinctUntilChanged()
    )
    .subscribe(text => {
      if(this.from === 'deploymentList'){
        this.action.emit(text.trim());
      }
    });
  }


}
